export interface HashableFile {
  name: string;
  size?: number;
  lastModified?: number;
}

export function calcHash(file: HashableFile) {
  if (typeof file['file'] !== 'undefined')
    throw new Error(
      'Do not use QueuedIntakeFileInfo here, use an original file object (the queued file has a prefix in the name and no lastModified)',
    );

  return `${file.name}_${file.size}_${file.lastModified}`;
}
